import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonavimumbaicab() {



  const cardData = {


  keyword: "Pune to Navi Mumbai Cab",

  headingDescription: "Trustline Travels offers reliable Pune to Navi Mumbai cab services with safe, comfortable, and affordable transportation for corporate travel, business meetings, airport transfers, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure punctual pickups and a smooth, hassle-free travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Navi Mumbai taxi services.",

  topPlaces: [
    {
      title: "Airoli",
      description: "Airoli is a leading commercial and IT destination in Navi Mumbai, home to multinational companies, technology parks, and modern business centers."
    },
    {
      title: "Ghansoli",
      description: "Ghansoli is a rapidly growing business locality featuring corporate campuses, IT companies, commercial complexes, and excellent connectivity."
    },
    {
      title: "Belapur CBD",
      description: "Belapur CBD serves as Navi Mumbai's administrative and commercial hub, housing government offices, corporate headquarters, and financial institutions."
    },
    {
      title: "Vashi",
      description: "Vashi is one of Navi Mumbai's busiest commercial districts, known for business centers, shopping complexes, educational institutions, and hotels."
    },
    {
      title: "Reliance Corporate Park",
      description: "Reliance Corporate Park in Ghansoli is a world-class business campus with technology centers, innovation facilities, and corporate offices."
    },
    {
      title: "TTC Industrial Area",
      description: "TTC Industrial Area is a major industrial corridor featuring manufacturing companies, logistics firms, engineering units, and commercial establishments."
    },
    {
      title: "Seawoods Grand Central",
      description: "Seawoods Grand Central is a modern lifestyle destination combining shopping, dining, entertainment, premium offices, and excellent connectivity."
    },
    {
      title: "Central Park Kharghar",
      description: "Central Park is one of Navi Mumbai's largest urban parks, offering beautiful gardens, walking trails, open spaces, and recreational activities."
    },
    {
      title: "Belapur Fort",
      description: "Belapur Fort is a historic attraction known for its ancient architecture, peaceful surroundings, and panoramic views of Navi Mumbai."
    },
    {
      title: "Flamingo Point",
      description: "Flamingo Point is a popular nature destination where visitors can enjoy seasonal flamingo sightings, mangrove landscapes, and birdwatching experiences."
    }
  ],






"services": [
  {
    "name": "Hinjewadi to Navi Mumbai Airport Cab",
    "description": "Book Hinjewadi to Navi Mumbai Airport cab with professional drivers, AC vehicles, and reliable airport transfer service for one-way and round-trip travel."
  },
  {
    "name": "Wakad to Navi Mumbai Airport Cab",
    "description": "Hire Wakad to Navi Mumbai Airport cab for comfortable airport transfers with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles."
  },
  {
    "name": "Baner to Navi Mumbai Airport Cab",
    "description": "Choose Baner to Navi Mumbai Airport cab for affordable airport travel with punctual pickup and experienced chauffeurs."
  },
  {
    "name": "Kharadi to Navi Mumbai Airport Cab",
    "description": "Book Kharadi to Navi Mumbai Airport cab with fixed fares, clean vehicles, and hassle-free airport transportation."
  },
  {
    "name": "Hadapsar to Navi Mumbai Airport Cab",
    "description": "Hire Hadapsar to Navi Mumbai Airport cab for safe, comfortable, and reliable airport transfers with doorstep pickup."
  },
  {
    "name": "Pimpri Chinchwad to Navi Mumbai Airport Cab",
    "description": "Book Pimpri Chinchwad to Navi Mumbai Airport cab for affordable one-way, round-trip, and airport transfer services."
  },
  {
    "name": "Viman Nagar to Navi Mumbai Airport Cab",
    "description": "Choose Viman Nagar to Navi Mumbai Airport cab with professional drivers, spacious luggage capacity, and timely airport drop."
  },
  {
    "name": "Kothrud to Navi Mumbai Airport Cab",
    "description": "Reserve Kothrud to Navi Mumbai Airport cab with transparent pricing and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Aundh to Navi Mumbai Airport Cab",
    "description": "Book Aundh to Navi Mumbai Airport cab for business travel, airport transfers, and family journeys."
  },
  {
    "name": "Shivajinagar to Navi Mumbai Airport Cab",
    "description": "Hire Shivajinagar to Navi Mumbai Airport cab with clean AC vehicles and experienced drivers for reliable airport travel."
  },
  {
    "name": "Pune to Navi Mumbai Airport Cab",
    "description": "Book Pune to Navi Mumbai Airport cab with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles for airport transfers and intercity travel."
  },
  {
    "name": "Pune to Navi Mumbai Airport Taxi",
    "description": "Travel comfortably with Pune to Navi Mumbai Airport taxi offering professional chauffeurs, fixed pricing, and 24x7 availability."
  },
  {
    "name": "Pune to Navi Mumbai Airport Cab Service",
    "description": "Choose Pune to Navi Mumbai Airport cab service for punctual airport transfers, clean vehicles, and affordable fares."
  },
  {
    "name": "Pune to Navi Mumbai Airport Cab Booking",
    "description": "Complete your Pune to Navi Mumbai Airport cab booking online with instant confirmation and multiple vehicle options."
  },
  {
    "name": "Book Pune to Navi Mumbai Airport Cab",
    "description": "Reserve Pune to Navi Mumbai Airport cab with doorstep pickup, transparent pricing, and experienced chauffeurs."
  },
  {
    "name": "Online Pune to Navi Mumbai Airport Cab",
    "description": "Book Pune to Navi Mumbai Airport cab online with secure booking, instant confirmation, and reliable service."
  },
  {
    "name": "Pune to Navi Mumbai Airport Cab Fare",
    "description": "Check Pune to Navi Mumbai Airport cab fare with fixed pricing for Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles."
  },
  {
    "name": "Pune to Navi Mumbai Airport Transfer",
    "description": "Book Pune to Navi Mumbai Airport transfer for smooth airport pickup and drop with professional drivers."
  },
  {
    "name": "One Way Pune to Navi Mumbai Airport Cab",
    "description": "Choose one way Pune to Navi Mumbai Airport cab and pay only for your single journey without return charges."
  },
  {
    "name": "Navi Mumbai International Airport Cab",
    "description": "Hire Navi Mumbai International Airport cab service for reliable airport transportation with comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Affordable Pune to Navi Mumbai Airport Cab",
    "description": "Book affordable Pune to Navi Mumbai Airport cab with budget-friendly fares, clean vehicles, and dependable service."
  },
  {
    "name": "Best Pune to Navi Mumbai Airport Cab Service",
    "description": "Choose the best Pune to Navi Mumbai Airport cab service for premium travel, professional drivers, and transparent pricing."
  },
  {
    "name": "Airport Taxi Pune to Navi Mumbai Airport",
    "description": "Airport taxi Pune to Navi Mumbai Airport offers timely pickup, flight tracking, and comfortable airport transportation."
  },
  {
    "name": "24x7 Pune to Navi Mumbai Airport Cab",
    "description": "Book 24x7 Pune to Navi Mumbai Airport cab anytime with round-the-clock customer support and reliable drivers."
  },
  {
    "name": "Fixed Fare Pune to Navi Mumbai Airport Cab",
    "description": "Choose fixed fare Pune to Navi Mumbai Airport cab with transparent pricing and no hidden charges."
  },
  {
    "name": "Pune to Navi Mumbai Cab",
    "description": "Book Pune to Navi Mumbai cab for business travel, airport transfers, family trips, and outstation journeys."
  },
  {
    "name": "Pune to Navi Mumbai Cab Service",
    "description": "Reliable Pune to Navi Mumbai cab service with professional drivers, AC vehicles, and affordable fares."
  },
  {
    "name": "Pune to Navi Mumbai Taxi",
    "description": "Hire Pune to Navi Mumbai taxi with clean cars, experienced chauffeurs, and flexible one-way or round-trip options."
  },
  {
    "name": "Pune to Navi Mumbai Taxi Service",
    "description": "Choose Pune to Navi Mumbai taxi service for comfortable intercity travel with transparent pricing and 24x7 support."
  },
  {
    "name": "Pune to Navi Mumbai Cab Booking",
    "description": "Book Pune to Navi Mumbai cab online with instant confirmation, multiple vehicle choices, and fixed fares."
  },
  {
    "name": "Online Pune to Navi Mumbai Cab",
    "description": "Reserve Pune to Navi Mumbai cab online for quick booking, secure payment, and reliable chauffeur service."
  },
  {
    "name": "Book Pune to Navi Mumbai Cab",
    "description": "Book Pune to Navi Mumbai cab with doorstep pickup, AC vehicles, and professional drivers."
  },
  {
    "name": "Pune to Navi Mumbai Taxi Booking",
    "description": "Complete Pune to Navi Mumbai taxi booking online with transparent fares and instant confirmation."
  },
  {
    "name": "Pune to Navi Mumbai One Way Cab",
    "description": "Book Pune to Navi Mumbai one way cab for affordable single-side travel without return charges."
  },
  {
    "name": "Pune to Navi Mumbai Round Trip Cab",
    "description": "Hire Pune to Navi Mumbai round trip cab with flexible waiting time, return options, and comfortable travel."
  }
],

"tableData": [
  ["Hinjewadi to Navi Mumbai Airport Cab", "Wakad to Navi Mumbai Airport Cab"],
  ["Baner to Navi Mumbai Airport Cab", "Kharadi to Navi Mumbai Airport Cab"],
  ["Hadapsar to Navi Mumbai Airport Cab", "Pimpri Chinchwad to Navi Mumbai Airport Cab"],
  ["Viman Nagar to Navi Mumbai Airport Cab", "Kothrud to Navi Mumbai Airport Cab"],
  ["Aundh to Navi Mumbai Airport Cab", "Shivajinagar to Navi Mumbai Airport Cab"],
  ["Pune to Navi Mumbai Airport Cab", "Pune to Navi Mumbai Airport Taxi"],
  ["Pune to Navi Mumbai Airport Cab Service", "Pune to Navi Mumbai Airport Cab Booking"],
  ["Book Pune to Navi Mumbai Airport Cab", "Online Pune to Navi Mumbai Airport Cab"],
  ["Pune to Navi Mumbai Airport Cab Fare", "Pune to Navi Mumbai Airport Transfer"],
  ["One Way Pune to Navi Mumbai Airport Cab", "Navi Mumbai International Airport Cab"],
  ["Affordable Pune to Navi Mumbai Airport Cab", "Best Pune to Navi Mumbai Airport Cab Service"],
  ["Airport Taxi Pune to Navi Mumbai Airport", "24x7 Pune to Navi Mumbai Airport Cab"],
  ["Fixed Fare Pune to Navi Mumbai Airport Cab", "Pune to Navi Mumbai Cab"],
  ["Pune to Navi Mumbai Cab Service", "Pune to Navi Mumbai Taxi"],
  ["Pune to Navi Mumbai Taxi Service", "Pune to Navi Mumbai Cab Booking"],
  ["Online Pune to Navi Mumbai Cab", "Book Pune to Navi Mumbai Cab"],
  ["Pune to Navi Mumbai Taxi Booking", "Pune to Navi Mumbai One Way Cab"],
  ["Pune to Navi Mumbai Round Trip Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Pune to Navi Mumbai Cab Service",
    WhyChoosedescription: "Trustline Cab provides dependable Pune to Navi Mumbai cab services with comfortable vehicles for business, family, and leisure travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "Enjoy convenient pickup from your home, office, hotel, Pune Airport, Pune Railway Station, and all major locations in Pune."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our skilled chauffeurs ensure a safe, smooth, and timely journey via the Pune-Mumbai Expressway to Navi Mumbai."
  },
  {
    WhyChooseheading: "Affordable Fare with No Hidden Charges",
    WhyChoosedescription: "Get transparent pricing, competitive cab fares, and detailed quotations before confirming your booking."
  },
  {
    WhyChooseheading: "Comfortable Fleet for Every Trip",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to match your travel requirements."
  },
  {
    WhyChooseheading: "One Way & Round Trip Booking",
    WhyChoosedescription: "Book one-way cabs, round trips, or customized travel packages for a flexible and convenient journey."
  },
  {
    WhyChooseheading: "Suitable for Corporate & Family Travel",
    WhyChoosedescription: "Our Pune to Navi Mumbai cab service is ideal for business meetings, family visits, hotel transfers, and outstation travel."
  },
  {
    WhyChooseheading: "Instant Booking Support",
    WhyChoosedescription: "Receive quick fare estimates, immediate booking confirmation, and dedicated customer assistance whenever you need a cab."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Navi Mumbai cab service?",
    answer: "Yes, Trustline Cab offers reliable Pune to Navi Mumbai cab services for one-way journeys, round trips, corporate travel, and family travel."
  },
  {
    question: "Can I book a one-way cab from Pune to Navi Mumbai?",
    answer: "Yes, we provide affordable one-way cab services with flexible pickup timings from any location in Pune."
  },
  {
    question: "Which vehicles are available for Pune to Navi Mumbai travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for every travel requirement."
  },
  {
    question: "Do you provide pickup from Pune Airport and Railway Station?",
    answer: "Yes, we offer pickup from Pune Airport, Pune Railway Station, hotels, offices, and residential locations across Pune."
  },
  {
    question: "Can I book a round-trip cab to Navi Mumbai?",
    answer: "Yes, Trustline Cab provides customized round-trip cab packages according to your travel schedule."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in your booking quotation."
  },
  {
    question: "Is Pune to Navi Mumbai cab service available 24/7?",
    answer: "Yes, our cab services operate round the clock for early morning, daytime, and late-night travel."
  },
  {
    question: "Can I reserve my cab before the travel date?",
    answer: "Yes, advance booking is recommended to ensure your preferred vehicle and pickup timing."
  },
  {
    question: "Do you provide cabs for business and corporate travel?",
    answer: "Yes, our cab service is widely used by corporate professionals, business executives, and frequent travelers."
  },
  {
    question: "How can I book a Pune to Navi Mumbai cab with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback: "Trustline Travels made my Pune to Navi Mumbai journey completely hassle-free. The cab arrived on time, the driver was courteous, and the vehicle was clean and comfortable throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shilpa Patil",
    feedback: "We booked a Pune to Navi Mumbai cab for a family visit, and the service was excellent. The booking process was smooth, the fare was transparent, and the journey was safe and relaxing.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Navi Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-navi-mumbai-cab.webp",
  "description": "Book Pune to Navi Mumbai cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, airport transfer, and outstation taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7643"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-navi-mumbai-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Pune to Navi Mumbai Cab | Airport & One Way Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Navi Mumbai cab service with Trustline Travels for reliable airport transfers and intercity travel. Get affordable Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Hinjewadi to Navi Mumbai Airport Cab, Wakad to Navi Mumbai Airport Cab, Baner to Navi Mumbai Airport Cab, Kharadi to Navi Mumbai Airport Cab, Hadapsar to Navi Mumbai Airport Cab, Pimpri Chinchwad to Navi Mumbai Airport Cab, Viman Nagar to Navi Mumbai Airport Cab, Kothrud to Navi Mumbai Airport Cab, Aundh to Navi Mumbai Airport Cab, Shivajinagar to Navi Mumbai Airport Cab, Pune to Navi Mumbai Cab, Pune to Navi Mumbai Airport Taxi, Pune Navi Mumbai one way cab, Pune to Navi Mumbai taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonavimumbaicab;